export default function FormUnavailable({ formName, availablePeriod, contacts = [] }) {
  return (
    <div className="container mx-auto flex min-h-screen flex-col items-center justify-center p-4">
      <div className="max-w-2xl rounded-lg bg-white p-8 shadow-lg">
        <h1 className="mb-4 text-2xl font-bold text-gray-800">{formName} Currently Unavailable</h1>
        <p className="mb-4 text-gray-600">
          The {formName} is only available during the following period:
        </p>
        <p className="mb-6 text-xl font-semibold text-blue-600">{availablePeriod}</p>
        <p className="text-gray-600">
          Please return during this time period to submit your appeal. If you have questions, please
          contact the Utah County Treasurer&apos;s Office.
        </p>
        {contacts.length > 0 && (
          <div className="mt-8 border-t pt-6">
            <h2 className="mb-2 font-semibold text-gray-800">Contact Information:</h2>
            {contacts.map((contact) => (
              <p key={contact.email} className="text-gray-600">
                <strong>{contact.name}:</strong>{' '}
                <a className="text-blue-600 hover:underline" href={`mailto:${contact.email}`}>
                  {contact.email}
                </a>
                {contact.phone && ` | ${contact.phone}`}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
